const serverRenderingUtils = require('../serverRenderingUtils');
const supportedLocalesJSON = require('../../client/i18n/locales.json');
const FALLBACK_LOCALES = require('../../client/i18n/fallbacks.json');

// Pulling Russian out of Localization launch until further notice
const SUPPORTED_LOCALES = new Set(
  Object.keys(supportedLocalesJSON).filter(locale => locale !== 'ru')
);

/**
 *  Looks in locales list if any is supported or we have a fallback, if not returns English
 *  @param {Array.<string>} locales - i.e. ['eu', 'fr', 'fr-CA', 'en']
 *  @return {string} - i.e. 'fr'
 * */
function resolveSupportedLocale(locales) {
  if (locales.includes('pseudo')) return 'pseudo';

  for (let i = 0; i < locales.length; i++) {
    const locale = locales[i];
    const language = locale.substring(0, 2);

    // Use detected locale if it's listed in supported locales
    if (SUPPORTED_LOCALES.has(locale)) return locale;

    // Otherwise look if there is a fallback for the detected locale
    if (FALLBACK_LOCALES[locale]) return FALLBACK_LOCALES[locale][0];

    // If neither work look by language
    if (SUPPORTED_LOCALES.has(language)) return language;
    if (FALLBACK_LOCALES[language]) return FALLBACK_LOCALES[language][0];
  }

  // If nothing matches, return English
  return 'en';
}

/**
 *  Strips weight quality value from Accept-Language Header values
 *  @param {string} languages - i.e. 'en-GB,en-US;q=0.9,fr-CA;q=0.7,en;q=0.8'
 *  @return {string[]} - i.e. ['en-GB,en-US,fr-CA,en']
 * */
function stripHeaderLanguagesWeight(languages) {
  return languages
    .split(',')
    .map(language =>
      language.includes(';')
        ? language.substring(0, language.indexOf(';'))
        : language
    );
}

function detectLocaleServer(req) {
  const locales = stripHeaderLanguagesWeight(
    req.headers['accept-language'] || ''
  );
  return resolveSupportedLocale(locales);
}

function detectLocaleClient() {
  let locales = [];
  if (!serverRenderingUtils.windowUndefined()) {
    locales = document.documentElement.getAttribute('lang')
      ? [document.documentElement.getAttribute('lang')]
      : window.navigator.languages || [];
  }
  return resolveSupportedLocale(locales);
}

module.exports = { detectLocaleServer, detectLocaleClient };
